import React from "react";
import {Route, Switch } from "react-router-dom";
import { useSubheader } from "../../../_metronic/layout";
import ReportDelegation from "./ReportDelegation";


export default function ReportDelegationPage() {
  const subheader = useSubheader();
  subheader.setTitle("Role Delegation");

  return (
    <div className="d-flex flex-row">
      <div className="flex-row-fluid">
        <Switch>
          {/* <Redirect from="/reportDelegation" exact={true} to="/reportDelegation" /> */}
          <Route path="/reportDelegation" component={ReportDelegation} />
        </Switch>
      </div>
    </div>
  );
}
